export default __webpack_public_path__ + "static/media/landing-atm.c5fe72a0.svg";